import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    IconButton,
    Stack,
    Typography
} from '@mui/material';
import { Add } from '@mui/icons-material';
import ComputerIcon from '@mui/icons-material/Computer';
import Delete from '@mui/icons-material/Delete';

const VirtualLabSection = ({
    lessonLabs,
    lectureId,
    handleDeleteLab,
    onAddLab,
    theme
}) => (
    <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center" gap={1}>
                <ComputerIcon
                    sx={{
                        color: theme.palette.secondary.main
                    }}
                />
                <Typography
                    variant="subtitle2"
                    sx={{
                        fontWeight: 600,
                        color: 'text.secondary'
                    }}
                >
                    Virtual Labs
                </Typography>
            </Box>
            <Chip
                label={`${lessonLabs?.length || 0} Lab${
                    lessonLabs?.length !== 1 ? 's' : ''
                }`}
                color={lessonLabs?.length > 0 ? 'secondary' : 'default'}
                size="small"
                sx={{
                    fontWeight: 600,
                    borderRadius: '6px'
                }}
            />
        </Box>

        {!lessonLabs || lessonLabs.length === 0 ? (
            <Box
                sx={{
                    border: `2px dashed ${theme.palette.divider}`,
                    borderRadius: '12px',
                    p: 4,
                    textAlign: 'center',
                    backgroundColor: theme.palette.grey[50]
                }}
            >
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontWeight: 500, mb: 0.5 }}
                >
                    No virtual labs added yet
                </Typography>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                >
                    Attach a virtual lab environment to this lesson. Click
                    &quot;Add Virtual Lab&quot; below to create one.
                </Typography>
            </Box>
        ) : (
            <Stack spacing={2.5}>
                {lessonLabs.map((lab, idx) => (
                    <Card
                        key={lab._id || idx}
                        variant="outlined"
                        sx={{
                            borderRadius: '12px',
                            borderLeft: `6px solid ${theme.palette.secondary.main}`
                        }}
                    >
                        <CardContent
                            sx={{
                                p: 2.5,
                                '&:last-child': { pb: 2.5 }
                            }}
                        >
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="flex-start"
                            >
                                <Box>
                                    <Typography
                                        variant="subtitle2"
                                        color="primary"
                                        sx={{ fontWeight: 700 }}
                                    >
                                        {lab.labName}
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        sx={{ wordBreak: 'break-all' }}
                                    >
                                        {lab.url}
                                    </Typography>
                                </Box>
                                <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() => handleDeleteLab(lab._id)}
                                >
                                    <Delete fontSize="small" />
                                </IconButton>
                            </Box>
                        </CardContent>
                    </Card>
                ))}
            </Stack>
        )}

        <Box display="flex" justifyContent="flex-end" mt={1}>
            <Button
                variant="outlined"
                color="secondary"
                startIcon={<Add />}
                onClick={onAddLab}
                sx={{
                    py: 1,
                    px: 3,
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    textTransform: 'none'
                }}
            >
                Add Virtual Lab
            </Button>
        </Box>
    </Box>
);

export default VirtualLabSection;
